// extracted by mini-css-extract-plugin
export default {"root":"SidebarPopup_root__nO4ZF","closeButton":"SidebarPopup_closeButton__cbWo4"};